@for (condition of conditionsRealValue(); track index; let index = $index) {
  @if (condition === 'AND' || condition === 'OR') {
    <div class="conditional__condition-command">
      <span class="fs__sm">{{ condition }}</span>
    </div>
  } @else {
    <div class="conditional__condition-saved">
      <div [matTooltip]="condition.infoLabel" class="eiq-id-badge">
        <span>{{ condition.questionId | qCode }}</span>
        @if (condition.cardId) {
          <span> - {{ condition.cardId }}</span>
        }
        @if (condition.optionId) {
          <span> - {{ condition.optionId }}</span>
        }
      </div>
      <div class="conditional__condition-saved-details">
        <span class="fs__md"> {{ operators[condition.operator] }}{{ !booleanOperators.includes(condition.operator) ? ':' : '' }} </span>
        <span
          [matTooltip]="rangeOperators.includes(condition.operator) ? '' : (condition.valueToMatch | joinValues)"
          class="conditional__condition-saved-values fs__md fw__500"
        >
          @if (rangeOperators.includes(condition.operator)) {
            "{{ condition.valueToMatch[0] }}" and "{{ condition.valueToMatch[1] }}"
          } @else {
            {{ condition.valueToMatchLabels | joinValues }}
          }
        </span>
      </div>

      <button mat-icon-button title="Delete Condition" color="warn" class="conditional__condition__remove-btn" (click)="removeCondition.emit(index)">
        <fa-icon [icon]="faTrashCan"></fa-icon>
      </button>
    </div>
  }
}
